import { render, staticRenderFns } from "./dealerpid.vue?vue&type=template&id=577a6964&scoped=true"
import script from "./dealerpid.vue?vue&type=script&lang=js"
export * from "./dealerpid.vue?vue&type=script&lang=js"
import style0 from "./dealerpid.vue?vue&type=style&index=0&id=577a6964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577a6964",
  null
  
)

export default component.exports